import React, { useEffect, useState, useContext } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  Image,
  Dimensions,
  Alert
} from "react-native";
//import { Image } from "react-native-expo-image-cache";
import { Video, AVPlaybackStatus } from 'expo-av';

import Text from "./Text";
import colors from "../config/colors";
import {
  AntDesign,
  MaterialCommunityIcons,
  Entypo,
  Fontisto,
  Foundation,
  Ionicons,
  FontAwesome5,
  Octicons,
} from "@expo/vector-icons";
import { ListItemAccount } from "./lists";
import { useNavigation } from '@react-navigation/native'; // esto te sirve para navegar en el ambiente donde invocaste este componente
import routes from "../navigation/routes";
import textStyles from "../config/textStyles";
import LikeBrainButton from "./LikeBrainButton";
//import useAuth from "../auth/useAuth";
import connectionConfig from "../config/settings";
//import PagerView from "react-native-pager-view";
import configurationPost from "../config/configurationPost";
//import CardSeed from "./CardSeed";
import CardSeedOriginContent from "./CardSeedOriginContent";
//import CardComponent from "./CardComponent";
import CardRequirements from "./CardRequirements";
import AuthContext from "../auth/context";


var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;
var textMini =  textStyles.textMini
var textSmall = textStyles.textSmall//(windowWidth * textStyles.textSmall)
var textLarge = ( textStyles.textLarge)
var textMedium = ( textStyles.textMedium)
var sizeBrainComments = ( textStyles.sizeBrainComments)// Tamaño icono cerebro y comments
var   seedNameOrigin40 =''


var sizeTree = (windowWidth * textStyles.sizeTree)
function CardFeedContent({
  alias,
  userDescription,
  title,
  subTitle,
  imageUrl,
  onPress,
  onPressLike,
  onPressComment,
  onPressNumLikes,
  thumbnailUrl,
  commentsNum,
  actionsNum,
  userPhoto,
  userPhotoFoundUser,
  userName,
  seedDescription,
  type,
  onPressShare,
  userId,
  followersSeed,
  statusLike,
  createDateSeed,
  onPressFolloresSeed,
  seedNameOrigin,
  seedDescriptionOrigin,
  seedPhotoOrigin,
  seedId,
  seedTotalActionsOrigin,
  seedTotalSeedLikesOrigin,
  seedTotalSeedFollowersOrigin,
  typeOrigin, 
  origin,
  onPressForOrigin ,
  youtubeId,
  originOfOrigin,
  myUserId,
  //........
  qty,
  mesure,
  unitaryPrice,
  currency,
  sub,
  note      
}) {
    // originOfOrigin,'     ' ,origin ,seedId ,typeOrigin, seedTotalSeedFollowersOrigin)
   //console.log("*** Content origin jeje en useEfect cardFeedContent ", title, seedId, typeOrigin)

useEffect(() => {
     console.log("*** Content origin jeje en useEfect cardFeedContent ",type, title, seedId, typeOrigin)

if (type === 44) {
    //console.log("*** Content en If 44 jeje en useEfect CardComponent ", typeOrigin, seedTotalSeedFollowersOrigin)
    selectMultiImages()
}
if (type === 40) {
   // console.log("*** Content en If 40 origin jeje en useEfect CardComponent ",
    // originOfOrigin,'     ' ,origin ,seedId ,typeOrigin, seedTotalSeedFollowersOrigin)
    selectOriginOfOrigin()
}
// if (type === 41) {
//     console.log("*** Content en If 41 origin jeje en useEfect CardComponent ",
//      originOfOrigin,'     ' ,origin ,seedId ,typeOrigin, seedTotalSeedFollowersOrigin)
//     selectOriginOfOrigin()
// }
}, []);

  const video = React.useRef(null);
  const [status, setStatus] = useState({});
  const [verMas, setVerMas] = useState(false);
  const navigation = useNavigation()

const { user, setUser } = useContext(AuthContext);  
  

  //const { user } = useAuth();
 var infoDocumetUri, perfilUri, webUrl, seedVideoUri 
if (connectionConfig.switchS3 === true) {
//console.log('CardComponent -> guarda las imagenes en un bucket de aws S3')
infoDocumetUri = connectionConfig.imageUrlS3
perfilUri = connectionConfig.imageUrlS3
webUrl = connectionConfig.imageUrlS3
seedVideoUri = connectionConfig.imageUrlS3
} else {
console.log('else switchS3')
infoDocumetUri = connectionConfig.imageUrl + '/Documents/'
perfilUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
webUrl = connectionConfig.imageUrl + '/seedImages/'
seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'
}

    

  //console.log('textMini', textMini)
//---------------------------------------------
//elementos para carrusel con pagination dots
//---------------------------------------------
const selectMultiImages = async () => {
        //console.log("*** Content en If 44 jeje en useEfect CardComponent ", "pi")
    var post_values = {
    /// userId: userId,
    seedId: seedId,
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/SelectMultplesImages/', configurationPost)
    .then(response => response.json())
    .then(response => {
        // console.log('/SelectMultplesImages/ -> pruebon' + seedId)
        //navigation.goBack();
        var arr = []
        arr = response.data
        setMultiImages(arr)
        // console.log('regresa cardComponent/SelectMultplesImages/ :)', response.data)
    })
    .catch(err => {
        console.log(':( review internet service /SelectMultplesImages/', err)
    })
}

//---------------------------------------------
//elementos del origen para el origen en un requriminto
//---------------------------------------------
const selectOriginOfOrigin = async () => {
       /// console.log("*** Content en If 44 jeje en useEfect CardComponent ", "pi")
    var post_values = {
    /// userId: userId,
    origin: originOfOrigin,
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/SelectOriginSeed/', configurationPost)
    .then(response => response.json())
    .then(response => {
        // console.log('/SelectMultplesImages/ -> pruebon' + seedId)
        //navigation.goBack();
  // seedNameOrigin40 = response.data[0].seedName
   setListing(response.data)
   console.log('regresa cardComponent/SelectMultplesImages/ :)', response.data[0].seedName, listing[0].seedName)

  // seedDescriptionOrigin,
  // seedPhotoOrigin,
  // seedId,
  // seedTotalActionsOrigin,
  // seedTotalSeedLikesOrigin,
  // seedTotalSeedFollowersOrigin,
  // typeOrigin, 

    
    })
    .catch(err => {
        console.log(':( review internet service /SelectOriginSeed/', err, type, '  ', seedId)
    })
}
const [multiImages, setMultiImages] = useState([])
const [currentIndex, setCurrentIndex] = useState(0);
const [listing, setListing] = useState([])// llena la lista de semillas
  
  const renderPage = (dataItem, num) => {
    var imageUrl = webUrl + dataItem.seedphoto

   // console.log(webUrl + dataItem.seedphoto)
    //console.log('    ' + imageUrl)
    return (
      <View key={dataItem.seedPhotoId} style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        {
          //.............................................
          //Sección que pinta imagenes o videos multiples
          //.............................................
          String(dataItem.seedphoto).includes('.jpg') === true ?
            <TouchableOpacity
              style={{
                width: '100%',
                height: '100%'
              }}
              onPress={() => {
                //console.log('pique la imagen', )
                try {
                  //setTimeout(function(){ navigation.navigate(routes.IMAGE_VISOR, {imageUrl})}, 3000);
                  console.log('boton que va al visor cardComponent ->  1', imageUrl)
                  navigation.navigate(routes.IMAGE_VISOR, { imageUrl })
                } catch (error) {
                  console.log('error del catch en boton que va al visor cardComponent ->  ', error)
                }
                // navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
              }}>
              <Image style={{
                width: '100%',
                height: '100%'
              }}
                resizeMode="contain"
                source={{ uri: imageUrl }}></Image></TouchableOpacity>
            :
            String(dataItem.seedphoto).includes('.jpeg') ?
              <TouchableOpacity
                onPress={() => {
                  //console.log('pique la imagen', )
                  try {
                    //setTimeout(function(){ navigation.navigate(routes.IMAGE_VISOR, {imageUrl})}, 3000);
                    console.log('boton que va al visor cardComponent ->  1', imageUrl)
                    navigation.navigate(routes.IMAGE_VISOR, { imageUrl })
                  } catch (error) {
                    console.log('error del catch en boton que va al visor cardComponent ->  ', error)
                  }
                  // navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
                }}>
                <Image style={{
                  width: '100%',
                  height: '100%'
                }}
                  resizeMode="contain"
                  source={{ uri: imageUrl }}></Image></TouchableOpacity>
              : String(dataItem.seedphoto).includes('.mp4') ?
                <Video
                  ref={video}
                  style={{
                    width: '100%',
                    height: '100%'
                  }}
                  source={{
                    uri: imageUrl
                  }}
                  useNativeControls
                  resizeMode="contain"
                  isLooping
                  onPlaybackStatusUpdate={status => setStatus(() => status)}
                />
                :
                String(dataItem.seedphoto).includes('.mov') ?
                  <Video
                    ref={video}
                    style={{
                      width: '100%',
                      height: '100%'
                    }}
                    source={{
                      uri: imageUrl
                    }}
                    useNativeControls
                    resizeMode="contain"
                    isLooping
                    onPlaybackStatusUpdate={status => setStatus(() => status)}
                  />
                  : String(dataItem.seedphoto).includes('.png') ?
                    <TouchableOpacity
                        style={{
                          width: '100%',
                          height: '100%'
                        }}
                      onPress={() => {
                        //console.log('pique la imagen', )
                        try {
                          //setTimeout(function(){ navigation.navigate(routes.IMAGE_VISOR, {imageUrl})}, 3000);
                          console.log('boton que va al visor cardComponent ->  1', imageUrl)
                          navigation.navigate(routes.IMAGE_VISOR, { imageUrl })
                        } catch (error) {
                          console.log('error del catch en boton que va al visor cardComponent ->  ', error)
                        }
                        // navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
                      }}> 

                          <Image style={{
                            width: '100%',
                            height: '100%',
                           // backgroundColor: 'red'
                          }}
                            resizeMode="contain"
                            source = {{ uri:imageUrl }}
                            />
                    
                        </TouchableOpacity>
                    :
                    <Text style={{
                      width: 150,
                      height: 150
                    }}>{dataItem.seedPhotoId + imageUrl} entre en null</Text>
        }

        {/* <Text style={{
          width: 50,
          height: 50
        }}>{dataItem.seedPhotoId} soy Id</Text> */}
      </View>
    );
  }

    switch (type) {
        
    //Conenido Texto
        case 33:
             return (
            //   <View style={styles.card}>
            //    <View style={styles.containerIcon}>
            //         {
                
            //             <View style={styles.viewIconAndNameAction}>

            //                 <Text style={styles.actionName}> Texto {type} </Text>

            //                 <Entypo style={{
            //                 // marginLeft:'55%'
            //                 marginLeft: (windowWidth * .26)
            //                 }}
            //                 name="share"
            //                 size={28}
            //                 color="grey"
            //                 onPress={onPressShare}
            //                 />
            //             </View>
                        
            //         }
            //         </View>
            //       </View>
                <View style={styles.card}>
                {/* <TouchableOpacity onPress={onPress}> */}
                <View>
                    <View style={styles.containerIcon}>
                    {
                
                        <View style={styles.viewIconAndNameAction}>

                            <Text style={styles.actionName}> Texto{type } </Text>

                            <Entypo style={{
                             marginLeft:'35%'
                            //marginLeft: (windowWidth * .066)
                            }}
                            name="share"
                            size={28}
                            color="grey"
                            onPress={onPressShare}
                            />
                        </View>
                        
                    }
                    </View>
                    {/* <Entypo style={{ marginLeft:'80%'}} name="share" size={28} color="black" onPress={onPressShare} /> */}
                    <Text style={styles.date}  >
                    Creada el 
                    {createDateSeed}
                    </Text>
                    <Text style={styles.title} >
                    {title}
                    </Text>

                    {seedDescription === null?
                            <Text style={styles.seedDescription} >
                            soy nulo
                            </Text>:
                    seedDescription.length > 150 ?
                    <Text style={styles.seedDescription}
                        numberOfLines={5}
                        onPress={() => {
                        setVerMas(true)
                        Alert.alert('Descripción de la semilla ' + title, seedDescription//,
                        )
                        console.log('ver más :) _', verMas)
                        }
                        }>
                        {seedDescription.substring(0, 200)} ... ver mas
                    </Text>
                    :
                    <Text style={styles.seedDescription} >
                        {seedDescription}
                    </Text>
                    }

                    {

                    }

                </View>

{/* <CardSeedOriginContent
//style={{width:'100%', height:200, backgroundColor:'blue'}}
title={seedNameOrigin}
subTitle={seedTotalSeedLikesOrigin} // 
//actionsNum={seedTotalActionsOrigin}
totalSeedFollowers={seedTotalActionsOrigin}
//commentsNum={totalSeedCommentsOrigin}
type={typeOrigin}
onPressNumLikes={() => {
    // indexLike = index
    // var pick = items[index].seedId
    navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId });
    console.log("presNumLique")
}
}
imageUrl={
    seedPhotoOrigin.includes('.mp4') ?
    seedPhotoOrigin :
    seedPhotoOrigin.includes('.mov') ?
        seedPhotoOrigin :
        seedPhotoOrigin}

onPress={() => {
    console.log('kkkkkkkkkkkkkkkkk', seedId)
    onPressForOrigin()
    // pickSeedId = items[index].seedId
    // getDataFromSeedActions()
    //navigation.navigate(routes.SEED_DETAILS, { origin }) //item
}
}

onPressLike={() => {
        console.log('pppppppppppppppppppppp')
    // indexLike = index
    // onPressValidationLikeUser()
}
}

onPressComment={() => {
        console.log('vvvvvvvvvvvv')

    navigation.navigate(routes.COMMENST_PUBLICATIONS, { item, origin })
}
}
thumbnailUrl={seedPhotoOrigin}
/> */}


                <ListItemAccount
                    titleRol={userName}
                    image={userPhoto}
                    onPress={() => {
                    if (userId !== JSON.parse(user).userId) {
                        var foundUserChecker = "foundUserChecker"
                        var index = 0
                        var item = { userId: userId, userName: userName, userPhoto: userPhotoFoundUser, alias: alias, userDescription: userDescription }
                        navigation.navigate(routes.FOUND_USER, { item, userId, foundUserChecker, index })
                    } else {
                        navigation.navigate(routes.NO_BOTTON)
                    }
                    }
                    }
                />
                {/* </TouchableOpacity> */}
                <View style={styles.detailsContainer}>

                    <View style={styles.likeAndCommentContainer}>
                    <View style={styles.likeContainer}>
                        <TouchableOpacity style={styles.subTitle}
                        onPress={onPressNumLikes}
                        >
                        <Text  // Número de cerebros like
                            numberOfLines={2}
                            style={styles.textNumLikes}
                        >

                            {
                            // '10000' +
                            subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            //intWithCommaFilter(subTitle)
                            //subTitle.toLocaleString()

                            // subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            // abc('10000' +
                            //   subTitle)
                            }
                        </Text>
                        </TouchableOpacity>
                        <LikeBrainButton style={styles.brain} onPress={onPressLike} statusLike={statusLike} />
                    </View>

                    <View style={styles.commentContainer}>
                        <Text style={styles.commentsNum} // Número de comments
                        numberOfLines={1} >
                        {commentsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </Text>
                        <TouchableOpacity style={styles.commentsNum}
                        onPress={onPressComment}
                        >
                        <MaterialCommunityIcons style={styles.comments}
                            name={"comment-text-outline"}
                            color={"grey"}
                            size={27}
                        />
                        </TouchableOpacity>
                    </View>

                    <View style={styles.actionContainer}>
                        {/* <TouchableOpacity style={styles.actionsNum} onPress={onPressNumLikes} >
                        </TouchableOpacity> */}
                        <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
                        numberOfLines={1} >
                        {actionsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </Text>
                        <Entypo name={"tree"}
                        color={"grey"}
                        size={27}
                        onPress={onPress}
                        style={styles.tree}
                        />
                    </View>
                    <View style={styles.followersSeedContainer}>
                        <TouchableOpacity
                        //style={styles.textFollower}
                        onPress={onPressFolloresSeed} >
                        <Text style={styles.textFollower} // Número de acciones(ramas)Tree
                        //numberOfLines={1}
                        >
                            {followersSeed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </Text>
                        <Ionicons style={styles.followersSeed}
                            name="people"
                            size={27}
                            color="grey"
                        />
                        </TouchableOpacity>
                    </View>
                    </View>
                </View>
                </View>
         ) 

// // photo or Video centro  <===  L I S T O !!
        case 35:
            return (
              <View style={styles.card}>
                {/* <TouchableOpacity onPress={onPress}> */}
                <View>
                  <View style={styles.containerIcon}>
                    {
                      type === 35 ?
                        <View style={styles.viewIconAndNameAction}>

                          <Text style={styles.actionName}>Contenido Imagen </Text>

                          <Entypo style={{
                            // marginLeft:'55%'
                            marginLeft: (windowWidth * .46)
                          }}
                            name="share"
                            size={28}
                            color="grey"
                            onPress={onPressShare}
                          />
                        </View>
                    
                      :
                      null
                    }
                  </View>
                  {/* <Entypo style={{ marginLeft:'80%'}} name="share" size={28} color="black" onPress={onPressShare} /> */}
                  <Text style={styles.date} // Número de comments
                    numberOfLines={1} >
                    {createDateSeed}
                  </Text>
                  <Text style={styles.title} >
                    {title}
                  </Text>

                  {seedDescription === null?
                            <Text style={styles.seedDescription} >
                            soy nulo
                          </Text>:
                  seedDescription.length > 150 ?
                    <Text style={styles.seedDescription}
                      numberOfLines={5}
                      onPress={() => {
                        setVerMas(true)
                        Alert.alert('Descripción de la semilla ' + title, seedDescription//,
                          //  [
                          //   {
                          //     text: "Cancel",
                          //     onPress: () => console.log("Cancel Pressed"),
                          //     style: 'destructive'
                          //    // style: "cancel"
                          //   },
                          //   { text: "OK", onPress: () => console.log("OK Pressed") }
                          // ]
                        )
                        console.log('ver más :) _', verMas)
                      }
                      }>
                      {seedDescription.substring(0, 200)} ... ver mas
                    </Text>
                    //   : verMas === true ?
                    //   <Text style={styles.seedDescription} 
                    //     onPress={ () => {
                    //         console.log('ver más :) _')
                    //         setVerMas = false
                    //     }
                    //     }>
                    //         {seedDescription} ... ver menos
                    //   </Text>
                    :
                    <Text style={styles.seedDescription} >
                      {seedDescription}
                    </Text>
                  }

                  {
                    imageUrl.includes('.mp4') ?
                      <Video
                        ref={video}
                        style={styles.image}
                        source={{
                          uri: imageUrl
                        }}
                        useNativeControls
                        resizeMode="contain"
                        isLooping
                        onPlaybackStatusUpdate={status => setStatus(() => status)}
                      />
                      :
                      imageUrl.includes('.mov') ?
                        <Video
                          ref={video}
                          style={styles.image}
                          source={{
                            uri: imageUrl
                          }}
                          useNativeControls
                          resizeMode="contain"
                          isLooping
                          onPlaybackStatusUpdate={status => setStatus(() => status)}
                        />
                        :
                        imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
                          <View style={styles.imageMountain} >
                            <Foundation //style={styles.imageMountain}
                              name="mountains"
                              size={350}
                              color={colors.medium} />
                          </View>
                          :
                          // <Image
                          //   onPress={onPress}
                          //   style={styles.image}
                          //   tint="light"
                          //   preview={{ uri: thumbnailUrl }}
                          //   source={{ uri: imageUrl }}
                          //   //uri={imageUrl}
                          // />
                          <TouchableOpacity
                            //   onPress={ () => {
                            //  console.log('pique la imagen', )

                            //  navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
                            //  }}
                            onPress={onPress}
                          >
                            <View style={styles.imageView}>
                              <Image
                                style={styles.image}
                                // tint="light"
                                //preview={{ uri: thumbnailUrl }}
                                //uri={imageUrl}
                                source={{ uri: imageUrl }}
                                resizeMode="contain"
                              />
                            </View>
                          </TouchableOpacity>
                  }
                </View>

<CardSeedOriginContent
//style={{width:'100%', height:200, backgroundColor:'blue'}}
title={seedNameOrigin}
subTitle={seedTotalSeedLikesOrigin} // 
//actionsNum={seedTotalActionsOrigin}
totalSeedFollowers={seedTotalActionsOrigin}
//commentsNum={totalSeedCommentsOrigin}
type={typeOrigin}
onPressNumLikes={() => {
    // indexLike = index
    // var pick = items[index].seedId
    navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId });
    console.log("presNumLique")
}
}
imageUrl={
    seedPhotoOrigin.includes('.mp4') ?
    seedPhotoOrigin :
    seedPhotoOrigin.includes('.mov') ?
        seedPhotoOrigin :
        seedPhotoOrigin}

onPress={() => {
    console.log('kkkkkkkkkkkkkkkkk', seedId)
    onPressForOrigin()
    // pickSeedId = items[index].seedId
    // getDataFromSeedActions()
    //navigation.navigate(routes.SEED_DETAILS, { origin }) //item
}
}

onPressLike={() => {
        console.log('pppppppppppppppppppppp')
    // indexLike = index
    // onPressValidationLikeUser()
}
}

onPressComment={() => {
        console.log('vvvvvvvvvvvv')

    navigation.navigate(routes.COMMENST_PUBLICATIONS, { item, origin })
}
}
thumbnailUrl={seedPhotoOrigin}
seedTotalSeedFollowersOrigin={seedTotalSeedFollowersOrigin}
//seedTotalActionsOrigin={0}

/>

                <ListItemAccount
                  titleRol={userName}
                  image={userPhoto}
                  onPress={() => {
                    if (userId !== JSON.parse(user).userId) {
                      var foundUserChecker = "foundUserChecker"
                      var index = 0
                      var item = { userId: userId, userName: userName, userPhoto: userPhotoFoundUser, alias: alias, userDescription: userDescription }
                      navigation.navigate(routes.FOUND_USER, { item, userId, foundUserChecker, index })
                    } else {
                      navigation.navigate(routes.NO_BOTTON)
                    }
                  }
                  }
                />
                {/* </TouchableOpacity> */}
                <View style={styles.detailsContainer}>

                  <View style={styles.likeAndCommentContainer}>
                    <View style={styles.likeContainer}>
                      <TouchableOpacity style={styles.subTitle}
                        onPress={onPressNumLikes}
                      >
                        <Text  // Número de cerebros like
                          numberOfLines={2}
                          style={styles.textNumLikes}
                        >

                          {
                            // '10000' +
                            subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            //intWithCommaFilter(subTitle)
                            //subTitle.toLocaleString()

                            // subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            // abc('10000' +
                            //   subTitle)
                          }
                        </Text>
                      </TouchableOpacity>
                      <LikeBrainButton style={styles.brain} onPress={onPressLike} statusLike={statusLike} />
                    </View>

                    <View style={styles.commentContainer}>
                      <Text style={styles.commentsNum} // Número de comments
                        numberOfLines={1} >
                        {commentsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      </Text>
                      <TouchableOpacity style={styles.commentsNum}
                        onPress={onPressComment}
                      >
                        <MaterialCommunityIcons style={styles.comments}
                          name={"comment-text-outline"}
                          color={"grey"}
                          size={27}
                        />
                      </TouchableOpacity>
                    </View>

                    <View style={styles.actionContainer}>
                      {/* <TouchableOpacity style={styles.actionsNum} onPress={onPressNumLikes} >
                      </TouchableOpacity> */}
                      <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
                        numberOfLines={1} >
                        {actionsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      </Text>
                      <Entypo name={"tree"}
                        color={"grey"}
                        size={27}
                        onPress={onPress}
                        style={styles.tree}
                      />
                    </View>
                    <View style={styles.followersSeedContainer}>
                      <TouchableOpacity
                        //style={styles.textFollower}
                        onPress={onPressFolloresSeed} >
                        <Text style={styles.textFollower} // Número de acciones(ramas)Tree
                        //numberOfLines={1}
                        >
                          {followersSeed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </Text>
                        <Ionicons style={styles.followersSeed}
                          name="people"
                          size={27}
                          color="grey"
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>
            )

// Add photo or Video to right and Text to the  ==> L E F T <==  L I S T O!!     
        case 36:
            return (
              <View style={styles.card}>
                {/* <TouchableOpacity onPress={onPress}> */}
                <View>
                  <View style={styles.containerIcon}>
                    {
                      type === 36 ?
                        <View style={styles.viewIconAndNameAction}>

                          <Text style={styles.actionName}> Imagen derecha{type}</Text>

                          <Entypo style={{
                            // marginLeft:'55%'
                            marginLeft: (windowWidth * .46)
                          }}
                            name="share"
                            size={28}
                            color="grey"
                            onPress={onPressShare}
                          />
                        </View>
                    
                      :
                      null
                    }
                  </View>
                  {/* <Entypo style={{ marginLeft:'80%'}} name="share" size={28} color="black" onPress={onPressShare} /> */}
                  <Text style={styles.date} // Número de comments
                    numberOfLines={1} >
                    {createDateSeed}
                  </Text>
                  {/* <Text style={styles.title} >
                    {title}
                  </Text>

                  {seedDescription === null?
                            <Text style={styles.seedDescription} >
                            soy nulo
                          </Text>:
                  seedDescription.length > 150 ?
                    <Text style={styles.seedDescription}
                      numberOfLines={5}
                      onPress={() => {
                        setVerMas(true)
                        Alert.alert('Descripción de la semilla ' + title, seedDescription//,
                          //  [
                          //   {
                          //     text: "Cancel",
                          //     onPress: () => console.log("Cancel Pressed"),
                          //     style: 'destructive'
                          //    // style: "cancel"
                          //   },
                          //   { text: "OK", onPress: () => console.log("OK Pressed") }
                          // ]
                        )
                        console.log('ver más :) _', verMas)
                      }
                      }>
                      {seedDescription.substring(0, 200)} ... ver mas
                    </Text>
                    //   : verMas === true ?
                    //   <Text style={styles.seedDescription} 
                    //     onPress={ () => {
                    //         console.log('ver más :) _')
                    //         setVerMas = false
                    //     }
                    //     }>
                    //         {seedDescription} ... ver menos
                    //   </Text>
                    :
                    <Text style={styles.seedDescription} >
                      {seedDescription}
                    </Text>
                  } */}

                  {/* {
                    imageUrl.includes('.mp4') ?
                      <Video
                        ref={video}
                        style={styles.image}
                        source={{
                          uri: imageUrl
                        }}
                        useNativeControls
                        resizeMode="contain"
                        isLooping
                        onPlaybackStatusUpdate={status => setStatus(() => status)}
                      />
                      :
                      imageUrl.includes('.mov') ?
                        <Video
                          ref={video}
                          style={styles.image}
                          source={{
                            uri: imageUrl
                          }}
                          useNativeControls
                          resizeMode="contain"
                          isLooping
                          onPlaybackStatusUpdate={status => setStatus(() => status)}
                        />
                        :
                        imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
                          <View style={styles.imageMountain} >
                            <Foundation //style={styles.imageMountain}
                              name="mountains"
                              size={350}
                              color={colors.medium} />
                          </View>
                          :
                          // <Image
                          //   onPress={onPress}
                          //   style={styles.image}
                          //   tint="light"
                          //   preview={{ uri: thumbnailUrl }}
                          //   source={{ uri: imageUrl }}
                          //   //uri={imageUrl}
                          // />
                          <TouchableOpacity
                            //   onPress={ () => {
                            //  console.log('pique la imagen', )

                            //  navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
                            //  }}
                            onPress={onPress}
                          >
                            <View style={styles.imageView}>
                              <Image
                                style={styles.image}
                                // tint="light"
                                //preview={{ uri: thumbnailUrl }}
                                //uri={imageUrl}
                                source={{ uri: imageUrl }}
                                resizeMode="contain"
                              />
                            </View>
                          </TouchableOpacity>
                  } */}

                   <View style={styles.viewContent6PhotoYText}  >
                              <View style={styles.viewContent7TitleYSeedDescription}>
                                {/* <Hyperlink linkStyle={ { color: '#2980b9', textDecorationLine: 'underline' } } 
                                                linkDefault={ true }
                                                > */}
                                <Text style={styles.Title6} >
                                  {title}
                                </Text>
                                {/* </Hyperlink> */}
                                {/* <Hyperlink linkStyle={ { color: '#2980b9', textDecorationLine: 'underline' } } 
                                            linkDefault={ true }
                                            > */}
                                <Text style={styles.seedDescription6} >
                                  {seedDescription}
                                </Text>
                                {/* </Hyperlink> */}
                              </View>
                  
                              <View style={styles.viewContent7Image} >
                                {
                                  imageUrl === null ?
                                    <View style={styles.imageMountain} >
                                      <Foundation //style={styles.imageMountain}
                                        name="mountains"
                                        size={350}
                                        color={colors.medium} />
                                    </View>
                                    :
                                    imageUrl.includes('.mp4') ?
                                      <Video
                                        ref={video}
                                        style={styles.image7}
                                        source={{
                                          uri: imageUrl
                                        }}
                                        useNativeControls
                                        resizeMode="contain"
                                        isLooping
                                        onPlaybackStatusUpdate={status => setStatus(() => status)}
                                      />
                                      :
                                      imageUrl.includes('.mov') ?
                                        <Video
                                          ref={video}
                                          style={styles.image7}
                                          source={{
                                            uri: imageUrl
                                          }}
                                          useNativeControls
                                          resizeMode="contain"
                                          isLooping
                                          onPlaybackStatusUpdate={status => setStatus(() => status)}
                                        />
                                        :
                                        imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
                                          <View style={styles.imageMountain} >
                                            <Foundation //style={styles.imageMountain}
                                              name="mountains"
                                              size={350}
                                              color={colors.medium} />
                                          </View>
                                          :
                                          // <View style={styles.viewImage7}>             
                                          //   <Image
                                          //     onPress={onPress}
                                          //     style={styles.image7}
                                          //     tint="light"
                                          //     preview={{ uri: thumbnailUrl }}
                                          //     source={{ uri: imageUrl }}
                                          //     resizeMode = "contain"
                                          //     //uri={imageUrl}
                                          //   />
                                          // </View>
                                          <TouchableOpacity style={styles.viewImage7}
                                            onPress={() => {
                                              // console.log("Onpress en CardComponent ", String(seedPhoto).substring(37, 41))
                                              //  var imageUrl = webUrl + seedPhoto 
                                              try {
                                                //setTimeout(function(){ navigation.navigate(routes.IMAGE_VISOR, {imageUrl})}, 3000);
                                                console.log('boton que va al visor cardComponent ->  3', imageUrl)
                                                navigation.navigate(routes.IMAGE_VISOR, { imageUrl })
                                              } catch (error) {
                                                console.log('error del catch en boton que va al visor cardComponent ->  ', error)
                                              }
                                              //navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
                                            }}
                                          >
                                          <Image
                                            style={styles.image7}
                                            // tint="light"
                                            //preview={{ uri: thumbnailUrl }}
                                            //uri={imageUrl}
                                            source={{ uri: imageUrl }}
                                            resizeMode="contain"
                                          />
                                          </TouchableOpacity >
                                }
                              </View>
                  
                            </View>
                </View>

<CardSeedOriginContent
//style={{width:'100%', height:200, backgroundColor:'blue'}}
title={seedNameOrigin}
subTitle={seedTotalSeedLikesOrigin} // 
//actionsNum={seedTotalActionsOrigin}
totalSeedFollowers={seedTotalActionsOrigin}
//commentsNum={totalSeedCommentsOrigin}
type={typeOrigin}
onPressNumLikes={() => {
    // indexLike = index
    // var pick = items[index].seedId
    navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId });
    console.log("presNumLique")
}
}
imageUrl={
    seedPhotoOrigin.includes('.mp4') ?
    seedPhotoOrigin :
    seedPhotoOrigin.includes('.mov') ?
        seedPhotoOrigin :
        seedPhotoOrigin}

onPress={() => {
    console.log('kkkkkkkkkkkkkkkkk', seedId)
    onPressForOrigin()
    // pickSeedId = items[index].seedId
    // getDataFromSeedActions()
    //navigation.navigate(routes.SEED_DETAILS, { origin }) //item
}
}

onPressLike={() => {
        console.log('pppppppppppppppppppppp')
    // indexLike = index
    // onPressValidationLikeUser()
}
}

onPressComment={() => {
        console.log('vvvvvvvvvvvv')

    navigation.navigate(routes.COMMENST_PUBLICATIONS, { item, origin })
}
}
thumbnailUrl={seedPhotoOrigin}
seedTotalSeedFollowersOrigin={seedTotalSeedFollowersOrigin}
//seedTotalActionsOrigin={0}

/>


                <ListItemAccount
                  titleRol={userName}
                  image={userPhoto}
                  onPress={() => {
                    if (userId !== JSON.parse(user).userId) {
                      var foundUserChecker = "foundUserChecker"
                      var index = 0
                      var item = { userId: userId, userName: userName, userPhoto: userPhotoFoundUser, alias: alias, userDescription: userDescription }
                      navigation.navigate(routes.FOUND_USER, { item, userId, foundUserChecker, index })
                    } else {
                      navigation.navigate(routes.NO_BOTTON)
                    }
                  }
                  }
                />
                {/* </TouchableOpacity> */}
                <View style={styles.detailsContainer}>

                  <View style={styles.likeAndCommentContainer}>
                    <View style={styles.likeContainer}>
                      <TouchableOpacity style={styles.subTitle}
                        onPress={onPressNumLikes}
                      >
                        <Text  // Número de cerebros like
                          numberOfLines={2}
                          style={styles.textNumLikes}
                        >

                          {
                            // '10000' +
                            subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            //intWithCommaFilter(subTitle)
                            //subTitle.toLocaleString()

                            // subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            // abc('10000' +
                            //   subTitle)
                          }
                        </Text>
                      </TouchableOpacity>
                      <LikeBrainButton style={styles.brain} onPress={onPressLike} statusLike={statusLike} />
                    </View>

                    <View style={styles.commentContainer}>
                      <Text style={styles.commentsNum} // Número de comments
                        numberOfLines={1} >
                        {commentsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      </Text>
                      <TouchableOpacity style={styles.commentsNum}
                        onPress={onPressComment}
                      >
                        <MaterialCommunityIcons style={styles.comments}
                          name={"comment-text-outline"}
                          color={"grey"}
                          size={27}
                        />
                      </TouchableOpacity>
                    </View>

                    <View style={styles.actionContainer}>
                      {/* <TouchableOpacity style={styles.actionsNum} onPress={onPressNumLikes} >
                      </TouchableOpacity> */}
                      <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
                        numberOfLines={1} >
                        {actionsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      </Text>
                      <Entypo name={"tree"}
                        color={"grey"}
                        size={27}
                        onPress={onPress}
                        style={styles.tree}
                      />
                    </View>
                    <View style={styles.followersSeedContainer}>
                      <TouchableOpacity
                        //style={styles.textFollower}
                        onPress={onPressFolloresSeed} >
                        <Text style={styles.textFollower} // Número de acciones(ramas)Tree
                        //numberOfLines={1}
                        >
                          {followersSeed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </Text>
                        <Ionicons style={styles.followersSeed}
                          name="people"
                          size={27}
                          color="grey"
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>
            )

 // Add photo or Video  with Text to the ==> R I G H T <==  L I S T O!!     
        case 37:
                        return (
              <View style={styles.card}>
                {/* <TouchableOpacity onPress={onPress}> */}
                <View>
                  <View style={styles.containerIcon}>
                    {
                      type === 37 ?
                        <View style={styles.viewIconAndNameAction}>

                          <Text style={styles.actionName}> Imagen izquierda{type}</Text>

                          <Entypo style={{
                            // marginLeft:'55%'
                            marginLeft: (windowWidth * .46)
                          }}
                            name="share"
                            size={28}
                            color="grey"
                            onPress={onPressShare}
                          />
                        </View>
                    
                      :
                      null
                    }
                  </View>
                  {/* <Entypo style={{ marginLeft:'80%'}} name="share" size={28} color="black" onPress={onPressShare} /> */}
                  <Text style={styles.date} // Número de comments
                    numberOfLines={1} >
                    {createDateSeed}
                  </Text>


                   <View style={styles.viewContent6PhotoYText}  >

                  
                              <View style={styles.viewContent6Image} >
                                {
                                  imageUrl === null ?
                                    <View style={styles.imageMountain} >
                                      <Foundation //style={styles.imageMountain}
                                        name="mountains"
                                        size={350}
                                        color={colors.medium} />
                                    </View>
                                    :
                                    imageUrl.includes('.mp4') ?
                                      <Video
                                        ref={video}
                                        style={styles.image7}
                                        source={{
                                          uri: imageUrl
                                        }}
                                        useNativeControls
                                        resizeMode="contain"
                                        isLooping
                                        onPlaybackStatusUpdate={status => setStatus(() => status)}
                                      />
                                      :
                                      imageUrl.includes('.mov') ?
                                        <Video
                                          ref={video}
                                          style={styles.image7}
                                          source={{
                                            uri: imageUrl
                                          }}
                                          useNativeControls
                                          resizeMode="contain"
                                          isLooping
                                          onPlaybackStatusUpdate={status => setStatus(() => status)}
                                        />
                                        :
                                        imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
                                          <View style={styles.imageMountain} >
                                            <Foundation //style={styles.imageMountain}
                                              name="mountains"
                                              size={350}
                                              color={colors.medium} />
                                          </View>
                                          :
                                          // <View style={styles.viewImage7}>             
                                          //   <Image
                                          //     onPress={onPress}
                                          //     style={styles.image7}
                                          //     tint="light"
                                          //     preview={{ uri: thumbnailUrl }}
                                          //     source={{ uri: imageUrl }}
                                          //     resizeMode = "contain"
                                          //     //uri={imageUrl}
                                          //   />
                                          // </View>
                                          <TouchableOpacity style={styles.viewImage7}
                                            onPress={() => {
                                              // console.log("Onpress en CardComponent ", String(seedPhoto).substring(37, 41))
                                              //  var imageUrl = webUrl + seedPhoto 
                                              try {
                                                //setTimeout(function(){ navigation.navigate(routes.IMAGE_VISOR, {imageUrl})}, 3000);
                                                console.log('boton que va al visor cardComponent ->  3', imageUrl)
                                                navigation.navigate(routes.IMAGE_VISOR, { imageUrl })
                                              } catch (error) {
                                                console.log('error del catch en boton que va al visor cardComponent ->  ', error)
                                              }
                                              //navigation.navigate(routes.IMAGE_VISOR, {imageUrl})
                                            }}
                                          >
                                          <Image
                                            style={styles.image7}
                                            // tint="light"
                                            //preview={{ uri: thumbnailUrl }}
                                            //uri={imageUrl}
                                            source={{ uri: imageUrl }}
                                            resizeMode="contain"
                                          />
                                          </TouchableOpacity >
                                }
                              </View>
                              <View style={styles.viewContent6TitleYSeedDescription}>
                                {/* <Hyperlink linkStyle={ { color: '#2980b9', textDecorationLine: 'underline' } } 
                                                linkDefault={ true }
                                                > */}
                                <Text style={styles.Title6} >
                                  {title}
                                </Text>
                                {/* </Hyperlink> */}
                                {/* <Hyperlink linkStyle={ { color: '#2980b9', textDecorationLine: 'underline' } } 
                                            linkDefault={ true }
                                            > */}
                                <Text style={styles.seedDescription6} >
                                  {seedDescription}
                                </Text>
                                {/* </Hyperlink> */}
                              </View>
                            </View>
                </View>

<CardSeedOriginContent
//style={{width:'100%', height:200, backgroundColor:'blue'}}
title={seedNameOrigin}
subTitle={seedTotalSeedLikesOrigin} // 
//actionsNum={seedTotalActionsOrigin}
totalSeedFollowers={seedTotalActionsOrigin}
//commentsNum={totalSeedCommentsOrigin}
type={typeOrigin}
onPressNumLikes={() => {
    // indexLike = index
    // var pick = items[index].seedId
    navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId });
    console.log("presNumLique")
}
}
imageUrl={
    seedPhotoOrigin.includes('.mp4') ?
    seedPhotoOrigin :
    seedPhotoOrigin.includes('.mov') ?
        seedPhotoOrigin :
        seedPhotoOrigin}

onPress={() => {
    console.log('kkkkkkkkkkkkkkkkk', seedId)
    onPressForOrigin()
    // pickSeedId = items[index].seedId
    // getDataFromSeedActions()
    //navigation.navigate(routes.SEED_DETAILS, { origin }) //item
}
}

onPressLike={() => {
        console.log('pppppppppppppppppppppp')
    // indexLike = index
    // onPressValidationLikeUser()
}
}

onPressComment={() => {
        console.log('vvvvvvvvvvvv')

    navigation.navigate(routes.COMMENST_PUBLICATIONS, { item, origin })
}
}
thumbnailUrl={seedPhotoOrigin}
seedTotalSeedFollowersOrigin={seedTotalSeedFollowersOrigin}
//seedTotalActionsOrigin={0}

/>


                <ListItemAccount
                  titleRol={userName}
                  image={userPhoto}
                  onPress={() => {
                    if (userId !== JSON.parse(user).userId) {
                      var foundUserChecker = "foundUserChecker"
                      var index = 0
                      var item = { userId: userId, userName: userName, userPhoto: userPhotoFoundUser, alias: alias, userDescription: userDescription }
                      navigation.navigate(routes.FOUND_USER, { item, userId, foundUserChecker, index })
                    } else {
                      navigation.navigate(routes.NO_BOTTON)
                    }
                  }
                  }
                />
                {/* </TouchableOpacity> */}
                <View style={styles.detailsContainer}>

                  <View style={styles.likeAndCommentContainer}>
                    <View style={styles.likeContainer}>
                      <TouchableOpacity style={styles.subTitle}
                        onPress={onPressNumLikes}
                      >
                        <Text  // Número de cerebros like
                          numberOfLines={2}
                          style={styles.textNumLikes}
                        >

                          {
                            // '10000' +
                            subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            //intWithCommaFilter(subTitle)
                            //subTitle.toLocaleString()

                            // subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            // abc('10000' +
                            //   subTitle)
                          }
                        </Text>
                      </TouchableOpacity>
                      <LikeBrainButton style={styles.brain} onPress={onPressLike} statusLike={statusLike} />
                    </View>

                    <View style={styles.commentContainer}>
                      <Text style={styles.commentsNum} // Número de comments
                        numberOfLines={1} >
                        {commentsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      </Text>
                      <TouchableOpacity style={styles.commentsNum}
                        onPress={onPressComment}
                      >
                        <MaterialCommunityIcons style={styles.comments}
                          name={"comment-text-outline"}
                          color={"grey"}
                          size={27}
                        />
                      </TouchableOpacity>
                    </View>

                    <View style={styles.actionContainer}>
                      {/* <TouchableOpacity style={styles.actionsNum} onPress={onPressNumLikes} >
                      </TouchableOpacity> */}
                      <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
                        numberOfLines={1} >
                        {actionsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      </Text>
                      <Entypo name={"tree"}
                        color={"grey"}
                        size={27}
                        onPress={onPress}
                        style={styles.tree}
                      />
                    </View>
                    <View style={styles.followersSeedContainer}>
                      <TouchableOpacity
                        //style={styles.textFollower}
                        onPress={onPressFolloresSeed} >
                        <Text style={styles.textFollower} // Número de acciones(ramas)Tree
                        //numberOfLines={1}
                        >
                          {followersSeed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </Text>
                        <Ionicons style={styles.followersSeed}
                          name="people"
                          size={27}
                          color="grey"
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>
            )
    // Y O U T U B E  V I D E O photo or Video  <===  L I S T O !!
        case 38:
            return (
                <View style={styles.card}>
                {/* <TouchableOpacity onPress={onPress}> */}
                <View>
                    <View style={styles.containerIcon}>
                    {
                        type === 38 ?
                        <View style={styles.viewIconAndNameAction}>

                            <Text style={styles.actionName}>Contenido Youtube </Text>

                            <Entypo style={{
                            // marginLeft:'55%'
                            marginLeft: (windowWidth * .46)
                            }}
                            name="share"
                            size={28}
                            color="grey"
                            onPress={onPressShare}
                            />
                        </View>
                    
                        :
                        null
                    }
                    </View>
                    {/* <Entypo style={{ marginLeft:'80%'}} name="share" size={28} color="black" onPress={onPressShare} /> */}
                    <Text style={styles.date} // Número de comments
                    numberOfLines={1} >
                    {createDateSeed}
                    </Text>
                    <Text style={styles.title} >
                    {title}
                    </Text>

                    {seedDescription === null?
                            <Text style={styles.seedDescription} >
                            soy nulo
                            </Text>:
                    seedDescription.length > 150 ?
                    <Text style={styles.seedDescription}
                        numberOfLines={5}
                        onPress={() => {
                        setVerMas(true)
                        Alert.alert('Descripción de la semilla ' + title, seedDescription//,
                            //  [
                            //   {
                            //     text: "Cancel",
                            //     onPress: () => console.log("Cancel Pressed"),
                            //     style: 'destructive'
                            //    // style: "cancel"
                            //   },
                            //   { text: "OK", onPress: () => console.log("OK Pressed") }
                            // ]
                        )
                        console.log('ver más :) _', verMas)
                        }
                        }>
                        {seedDescription.substring(0, 200)} ... ver mas
                    </Text>
                    //   : verMas === true ?
                    //   <Text style={styles.seedDescription} 
                    //     onPress={ () => {
                    //         console.log('ver más :) _')
                    //         setVerMas = false
                    //     }
                    //     }>
                    //         {seedDescription} ... ver menos
                    //   </Text>
                    :
                    <Text style={styles.seedDescription} >
                        {seedDescription}
                    </Text>
                    }

                    <Text style={styles.seedDescription} >
                        soy id youtube{youtubeId}
                    </Text>
            <TouchableOpacity
              style={styles.youtubeVideo}
              onPress={() => {
                console.log('IMAGE_VISOR -> youtubeId', youtubeId)
                var imageUrl = ''
                var messageYoutube = youtubeId
                navigation.navigate(routes.IMAGE_VISOR, { messageYoutube, imageUrl })
              }}>
              <View style={{ flexDirection: 'row', alignSelf:'center'}}>
                <Text style={styles.txtYoutube}>
                  Ver video
                </Text>
                <AntDesign name="youtube" size={28} color={colors.primary} />
              </View>

              <Image source={{ uri: 'http://img.youtube.com/vi/' + youtubeId + '/hqdefault.jpg' }}
                style={{ width: '100%', height: 200, backgroundColor: colors.aguacateGreen }} />

            </TouchableOpacity>
          
                </View>

<CardSeedOriginContent
//style={{width:'100%', height:200, backgroundColor:'blue'}}
title={seedNameOrigin}
subTitle={seedTotalSeedLikesOrigin} // 
//actionsNum={seedTotalActionsOrigin}
totalSeedFollowers={seedTotalActionsOrigin}
//commentsNum={totalSeedCommentsOrigin}
type={typeOrigin}
onPressNumLikes={() => {
    // indexLike = index
    // var pick = items[index].seedId
    navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId });
    console.log("presNumLique")
}
}
imageUrl={
    seedPhotoOrigin.includes('.mp4') ?
    seedPhotoOrigin :
    seedPhotoOrigin.includes('.mov') ?
        seedPhotoOrigin :
        seedPhotoOrigin}

onPress={() => {
    console.log('kkkkkkkkkkkkkkkkk', seedId)
    onPressForOrigin()
    // pickSeedId = items[index].seedId
    // getDataFromSeedActions()
    //navigation.navigate(routes.SEED_DETAILS, { origin }) //item
}
}

onPressLike={() => {
        console.log('pppppppppppppppppppppp')
    // indexLike = index
    // onPressValidationLikeUser()
}
}

onPressComment={() => {
        console.log('vvvvvvvvvvvv')

    navigation.navigate(routes.COMMENST_PUBLICATIONS, { item, origin })
}
}
thumbnailUrl={seedPhotoOrigin}
seedTotalSeedFollowersOrigin={seedTotalSeedFollowersOrigin}
//seedTotalActionsOrigin={0}

/>
                
                <ListItemAccount
                    titleRol={userName}
                    image={userPhoto}
                    onPress={() => {
                    if (userId !== JSON.parse(user).userId) {
                        var foundUserChecker = "foundUserChecker"
                        var index = 0
                        var item = { userId: userId, userName: userName, userPhoto: userPhotoFoundUser, alias: alias, userDescription: userDescription }
                        navigation.navigate(routes.FOUND_USER, { item, userId, foundUserChecker, index })
                    } else {
                        navigation.navigate(routes.NO_BOTTON)
                    }
                    }
                    }
                />
                {/* </TouchableOpacity> */}
                <View style={styles.detailsContainer}>

                    <View style={styles.likeAndCommentContainer}>
                    <View style={styles.likeContainer}>
                        <TouchableOpacity style={styles.subTitle}
                        onPress={onPressNumLikes}
                        >
                        <Text  // Número de cerebros like
                            numberOfLines={2}
                            style={styles.textNumLikes}
                        >

                            {
                            // '10000' +
                            subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            //intWithCommaFilter(subTitle)
                            //subTitle.toLocaleString()

                            // subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            // abc('10000' +
                            //   subTitle)
                            }
                        </Text>
                        </TouchableOpacity>
                        <LikeBrainButton style={styles.brain} onPress={onPressLike} statusLike={statusLike} />
                    </View>

                    <View style={styles.commentContainer}>
                        <Text style={styles.commentsNum} // Número de comments
                        numberOfLines={1} >
                        {commentsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </Text>
                        <TouchableOpacity style={styles.commentsNum}
                        onPress={onPressComment}
                        >
                        <MaterialCommunityIcons style={styles.comments}
                            name={"comment-text-outline"}
                            color={"grey"}
                            size={27}
                        />
                        </TouchableOpacity>
                    </View>

                    <View style={styles.actionContainer}>
                        {/* <TouchableOpacity style={styles.actionsNum} onPress={onPressNumLikes} >
                        </TouchableOpacity> */}
                        <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
                        numberOfLines={1} >
                        {actionsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </Text>
                        <Entypo name={"tree"}
                        color={"grey"}
                        size={27}
                        onPress={onPress}
                        style={styles.tree}
                        />
                    </View>
                    <View style={styles.followersSeedContainer}>
                        <TouchableOpacity
                        //style={styles.textFollower}
                        onPress={onPressFolloresSeed} >
                        <Text style={styles.textFollower} // Número de acciones(ramas)Tree
                        //numberOfLines={1}
                        >
                            {followersSeed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </Text>
                        <Ionicons style={styles.followersSeed}
                            name="people"
                            size={27}
                            color="grey"
                        />
                        </TouchableOpacity>
                    </View>
                    </View>
                </View>
                </View>
            )       
            
//     //Multiples photos or Videos  <===  :) !!
//       case 44:
//       return (
//                 <View style={styles.card}>
//                 {/* <TouchableOpacity onPress={onPress}> */}
//                 <View>
//                     <View style={styles.containerIcon}>
//                     {
//                         type === 44 ?
//                         <View style={styles.viewIconAndNameAction}>

//                             <Text style={styles.actionName}>Contenido Multi Imagen </Text>

//                             <Entypo style={{
//                             // marginLeft:'55%'
//                             marginLeft: (windowWidth * .46)
//                             }}
//                             name="share"
//                             size={28}
//                             color="grey"
//                             onPress={onPressShare}
//                             />
//                         </View>
                    
//                         :
//                         null
//                     }
//                     </View>
//                     {/* <Entypo style={{ marginLeft:'80%'}} name="share" size={28} color="black" onPress={onPressShare} /> */}
//                     <Text style={styles.date} // Número de comments
//                     numberOfLines={1} >
//                     {createDateSeed}
//                     </Text>
//                     <Text style={styles.title} >
//                     {title}
//                     </Text>

//                     {seedDescription === null?
//                             <Text style={styles.seedDescription} >
//                             soy nulo
//                             </Text>:
//                     seedDescription.length > 150 ?
//                     <Text style={styles.seedDescription}
//                         numberOfLines={5}
//                         onPress={() => {
//                         setVerMas(true)
//                         Alert.alert('Descripción de la semilla ' + title, seedDescription//,
//                             //  [
//                             //   {
//                             //     text: "Cancel",
//                             //     onPress: () => console.log("Cancel Pressed"),
//                             //     style: 'destructive'
//                             //    // style: "cancel"
//                             //   },
//                             //   { text: "OK", onPress: () => console.log("OK Pressed") }
//                             // ]
//                         )
//                         console.log('ver más :) _', verMas)
//                         }
//                         }>
//                         {seedDescription.substring(0, 200)} ... ver mas
//                     </Text>
//                     //   : verMas === true ?
//                     //   <Text style={styles.seedDescription} 
//                     //     onPress={ () => {
//                     //         console.log('ver más :) _')
//                     //         setVerMas = false
//                     //     }
//                     //     }>
//                     //         {seedDescription} ... ver menos
//                     //   </Text>
//                     :
//                     <Text style={styles.seedDescription} >
//                         {seedDescription}
//                     </Text>
//                     }
//           {
//             //................................................
//             //Aqui se pinta el carrusel de multiples imagenes
//             //................................................
//           }
//           <View style={{
//             width: '100%',
//             height: 450,
//           }}>
//             <View
//               style={{ flex: 1}}
//               initialPage={0}
//               onPageSelected={(event) => setCurrentIndex(event.nativeEvent.position)}
//             >
//               {multiImages.map((item) => renderPage(item, multiImages.length))}
//             </View>
//             <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 10 }}>
//               {multiImages.map((item, index) => (

//                 <View key={item.seedPhotoId}>
//                   <TouchableOpacity
//                     onPress={() => {
//                       console.log('index - >' + index + item.seedPhotoId)
//                       setCurrentIndex(index)
//                     }}
//                     // key={item.seedPhotoId}
//                     style={{
//                       marginTop: index === currentIndex ? 0 : 4,
//                       width: index === currentIndex ? 20 : 10,
//                       height: index === currentIndex ? 20 : 10,
//                       borderRadius: 25,
//                       backgroundColor: index === currentIndex ? colors.green : 'gray',
//                       margin: 5,
//                     }}
//                   />
//                 </View>


//               ))}
//             </View>
//             <View style={{ flexDirection: 'row', justifyContent: 'center', }}>
//               {multiImages.map((item, index) => (
//                 <View key={item.seedPhotoId}>
//                   {
//                     index === currentIndex ?
//                       <Text
//                         style={{
//                           width: 50,
//                           height: 50
//                         }}>  {(index + 1)} / {multiImages.length}
//                       </Text>
//                       :
//                       null
//                   }
//                 </View>
//               ))}
//             </View>
//           </View>

//                 </View>

// <CardSeedOriginContent
// //style={{width:'100%', height:200, backgroundColor:'blue'}}
// title={seedNameOrigin}
// subTitle={seedTotalSeedLikesOrigin} // 
// //actionsNum={seedTotalActionsOrigin}
// totalSeedFollowers={seedTotalActionsOrigin}
// //commentsNum={totalSeedCommentsOrigin}
// type={typeOrigin}
// onPressNumLikes={() => {
//     // indexLike = index
//     // var pick = items[index].seedId
//     navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId });
//     console.log("presNumLique")
// }
// }
// imageUrl={seedPhotoOrigin }

// onPress={() => {
//     console.log('kkkkkkkkkkkkkkkkk', seedId)
//     onPressForOrigin()
//     // pickSeedId = items[index].seedId
//     // getDataFromSeedActions()
//     //navigation.navigate(routes.SEED_DETAILS, { origin }) //item
// }
// }

// onPressLike={() => {
//         console.log('pppppppppppppppppppppp')
//     // indexLike = index
//     // onPressValidationLikeUser()
// }
// }

// onPressComment={() => {
//         console.log('vvvvvvvvvvvv')

//     navigation.navigate(routes.COMMENST_PUBLICATIONS, { item, origin })
// }
// }
// thumbnailUrl={seedPhotoOrigin}
// seedTotalSeedFollowersOrigin={seedTotalSeedFollowersOrigin}
// //seedTotalActionsOrigin={0}
// />     
//                 <ListItemAccount
//                     titleRol={userName}
//                     image={userPhoto}
//                     onPress={() => {
//                     if (userId !== JSON.parse(user).userId) {
//                         var foundUserChecker = "foundUserChecker"
//                         var index = 0
//                         var item = { userId: userId, userName: userName, userPhoto: userPhotoFoundUser, alias: alias, userDescription: userDescription }
//                         navigation.navigate(routes.FOUND_USER, { item, userId, foundUserChecker, index })
//                     } else {
//                         navigation.navigate(routes.NO_BOTTON)
//                     }
//                     }
//                     }
//                 />
//                 {/* </TouchableOpacity> */}
//                 <View style={styles.detailsContainer}>

//                     <View style={styles.likeAndCommentContainer}>
//                     <View style={styles.likeContainer}>
//                         <TouchableOpacity style={styles.subTitle}
//                         onPress={onPressNumLikes}
//                         >
//                         <Text  // Número de cerebros like
//                             numberOfLines={2}
//                             style={styles.textNumLikes}
//                         >

//                             {
//                             // '10000' +
//                             subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//                             //intWithCommaFilter(subTitle)
//                             //subTitle.toLocaleString()

//                             // subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//                             // abc('10000' +
//                             //   subTitle)
//                             }
//                         </Text>
//                         </TouchableOpacity>
//                         <LikeBrainButton style={styles.brain} onPress={onPressLike} statusLike={statusLike} />
//                     </View>

//                     <View style={styles.commentContainer}>
//                         <Text style={styles.commentsNum} // Número de comments
//                         numberOfLines={1} >
//                         {commentsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                         </Text>
//                         <TouchableOpacity style={styles.commentsNum}
//                         onPress={onPressComment}
//                         >
//                         <MaterialCommunityIcons style={styles.comments}
//                             name={"comment-text-outline"}
//                             color={"grey"}
//                             size={27}
//                         />
//                         </TouchableOpacity>
//                     </View>

//                     <View style={styles.actionContainer}>
//                         {/* <TouchableOpacity style={styles.actionsNum} onPress={onPressNumLikes} >
//                         </TouchableOpacity> */}
//                         <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
//                         numberOfLines={1} >
//                         {actionsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                         </Text>
//                         <Entypo name={"tree"}
//                         color={"grey"}
//                         size={27}
//                         onPress={onPress}
//                         style={styles.tree}
//                         />
//                     </View>
//                     <View style={styles.followersSeedContainer}>
//                         <TouchableOpacity
//                         //style={styles.textFollower}
//                         onPress={onPressFolloresSeed} >
//                         <Text style={styles.textFollower} // Número de acciones(ramas)Tree
//                         //numberOfLines={1}
//                         >
//                             {followersSeed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                         </Text>
//                         <Ionicons style={styles.followersSeed}
//                             name="people"
//                             size={27}
//                             color="grey"
//                         />
//                         </TouchableOpacity>
//                     </View>
//                     </View>
//                 </View>
//                 </View>
//       );

// //     R E Q U I R E M E N T 
//         case 39:
//             return (
//               <View style={styles.card}>
//                 {/* <TouchableOpacity onPress={onPress}> */}
//                 <View>
//                   <View style={styles.containerIcon}>
//                     {
//                       type === 39 ?
//                         <View style={styles.viewIconAndNameAction}>

//                           <Text style={styles.actionName}>Contenido Requerimiento </Text>

//                           <Entypo style={{
//                             // marginLeft:'55%'
//                             marginLeft: (windowWidth * .30)
//                           }}
//                             name="share"
//                             size={28}
//                             color="grey"
//                             onPress={onPressShare}
//                           />
//                         </View>
                    
//                       :
//                       null
//                     }
//                   </View>
//                   {/* <Entypo style={{ marginLeft:'80%'}} name="share" size={28} color="black" onPress={onPressShare} /> */}
//                   <Text style={styles.date} // Número de comments
//                     numberOfLines={1} >
//                     {createDateSeed}
//                   </Text>
//                   <Text style={styles.title} >
//                     {title}
//                   </Text>

//                   {seedDescription === null?
//                             <Text style={styles.seedDescription} >
//                             soy nulo
//                           </Text>:
//                   seedDescription.length > 150 ?
//                     <Text style={styles.seedDescription}
//                       numberOfLines={5}
//                       onPress={() => {
//                         setVerMas(true)
//                         Alert.alert('Descripción de la semilla ' + title, seedDescription//,
//                           //  [
//                           //   {
//                           //     text: "Cancel",
//                           //     onPress: () => console.log("Cancel Pressed"),
//                           //     style: 'destructive'
//                           //    // style: "cancel"
//                           //   },
//                           //   { text: "OK", onPress: () => console.log("OK Pressed") }
//                           // ]
//                         )
//                         console.log('ver más :) _', verMas)
//                       }
//                       }>
//                       {seedDescription.substring(0, 200)} ... ver mas
//                     </Text>
//                     //   : verMas === true ?
//                     //   <Text style={styles.seedDescription} 
//                     //     onPress={ () => {
//                     //         console.log('ver más :) _')
//                     //         setVerMas = false
//                     //     }
//                     //     }>
//                     //         {seedDescription} ... ver menos
//                     //   </Text>
//                     :
//                     <Text style={styles.seedDescription} >
//                       {seedDescription}
//                     </Text>
//                   }

//                 </View>

// <CardSeedOriginContent
// //style={{width:'100%', height:200, backgroundColor:'blue'}}
// title={seedNameOrigin}
// subTitle={seedTotalSeedLikesOrigin} // 
// //actionsNum={seedTotalActionsOrigin}
// totalSeedFollowers={seedTotalActionsOrigin}
// //commentsNum={totalSeedCommentsOrigin}
// type={typeOrigin}
// onPressNumLikes={() => {
//     // indexLike = index
//     // var pick = items[index].seedId
//     navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId });
//     console.log("presNumLique")
// }
// }
// imageUrl={
//     seedPhotoOrigin.includes('.mp4') ?
//     seedPhotoOrigin :
//     seedPhotoOrigin.includes('.mov') ?
//         seedPhotoOrigin :
//         seedPhotoOrigin}

// onPress={() => {
//     console.log('kkkkkkkkkkkkkkkkk', seedId)
//     onPressForOrigin()
//     // pickSeedId = items[index].seedId
//     // getDataFromSeedActions()
//     //navigation.navigate(routes.SEED_DETAILS, { origin }) //item
// }
// }

// onPressLike={() => {
//         console.log('pppppppppppppppppppppp')
//     // indexLike = index
//     // onPressValidationLikeUser()
// }
// }

// onPressComment={() => {
//         console.log('vvvvvvvvvvvv')

//     navigation.navigate(routes.COMMENST_PUBLICATIONS, { item, origin })
// }
// }
// thumbnailUrl={seedPhotoOrigin}
// seedTotalSeedFollowersOrigin={seedTotalSeedFollowersOrigin}
// //seedTotalActionsOrigin={0}

// />

//                 <ListItemAccount
//                   titleRol={userName}
//                   image={userPhoto}
//                   onPress={() => {
//                     if (userId !== JSON.parse(user).userId) {
//                       var foundUserChecker = "foundUserChecker"
//                       var index = 0
//                       var item = { userId: userId, userName: userName, userPhoto: userPhotoFoundUser, alias: alias, userDescription: userDescription }
//                       navigation.navigate(routes.FOUND_USER, { item, userId, foundUserChecker, index })
//                     } else {
//                       navigation.navigate(routes.NO_BOTTON)
//                     }
//                   }
//                   }
//                 />
//                 {/* </TouchableOpacity> */}
//                 <View style={styles.detailsContainer}>

//                   <View style={styles.likeAndCommentContainer}>
//                     <View style={styles.likeContainer}>
//                       <TouchableOpacity style={styles.subTitle}
//                         onPress={onPressNumLikes}
//                       >
//                         <Text  // Número de cerebros like
//                           numberOfLines={2}
//                           style={styles.textNumLikes}
//                         >

//                           {
//                             // '10000' +
//                             subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//                             //intWithCommaFilter(subTitle)
//                             //subTitle.toLocaleString()

//                             // subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//                             // abc('10000' +
//                             //   subTitle)
//                           }
//                         </Text>
//                       </TouchableOpacity>
//                       <LikeBrainButton style={styles.brain} onPress={onPressLike} statusLike={statusLike} />
//                     </View>

//                     <View style={styles.commentContainer}>
//                       <Text style={styles.commentsNum} // Número de comments
//                         numberOfLines={1} >
//                         {commentsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                       </Text>
//                       <TouchableOpacity style={styles.commentsNum}
//                         onPress={onPressComment}
//                       >
//                         <MaterialCommunityIcons style={styles.comments}
//                           name={"comment-text-outline"}
//                           color={"grey"}
//                           size={27}
//                         />
//                       </TouchableOpacity>
//                     </View>

//                     <View style={styles.actionContainer}>
//                       {/* <TouchableOpacity style={styles.actionsNum} onPress={onPressNumLikes} >
//                       </TouchableOpacity> */}
//                       <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
//                         numberOfLines={1} >
//                         {actionsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                       </Text>
//                       <Entypo name={"tree"}
//                         color={"grey"}
//                         size={27}
//                         onPress={onPress}
//                         style={styles.tree}
//                       />
//                     </View>
//                     <View style={styles.followersSeedContainer}>
//                       <TouchableOpacity
//                         //style={styles.textFollower}
//                         onPress={onPressFolloresSeed} >
//                         <Text style={styles.textFollower} // Número de acciones(ramas)Tree
//                         //numberOfLines={1}
//                         >
//                           {followersSeed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                         </Text>
//                         <Ionicons style={styles.followersSeed}
//                           name="people"
//                           size={27}
//                           color="grey"
//                         />
//                       </TouchableOpacity>
//                     </View>
//                   </View>
//                 </View>
//               </View>
//             ) 
//     // Add  S U B - R E Q U I R E M E N T   
//         case 40:
//             return (
//               <View style={styles.card}>
//                 {/* <TouchableOpacity onPress={onPress}> */}
//                 <View>
//                   <View style={styles.containerIcon}>
//                     {
//                       type === 40 ?
//                         <View style={styles.viewIconAndNameAction}>

//                           <Text style={styles.actionName}>Contenido Subrequerimiento </Text>

//                           <Entypo style={{
//                             // marginLeft:'55%'
//                             marginLeft: (windowWidth * .30)
//                           }}
//                             name="share"
//                             size={28}
//                             color="grey"
//                             onPress={onPressShare}
//                           />
//                         </View>
                    
//                       :
//                       null
//                     }
//                   </View>
//                   {/* <Entypo style={{ marginLeft:'80%'}} name="share" size={28} color="black" onPress={onPressShare} /> */}
//                   <Text style={styles.date} // Número de comments
//                     numberOfLines={1} >
//                     {createDateSeed}
//                   </Text>
//                   <Text style={styles.title} >
//                     {title}
//                   </Text>

//                   {seedDescription === null?
//                             <Text style={styles.seedDescription} >
//                             soy nulo
//                           </Text>:
//                   seedDescription.length > 150 ?
//                     <Text style={styles.seedDescription}
//                       numberOfLines={5}
//                       onPress={() => {
//                         setVerMas(true)
//                         Alert.alert('Descripción de la semilla ' + title, seedDescription//,
//                           //  [
//                           //   {
//                           //     text: "Cancel",
//                           //     onPress: () => console.log("Cancel Pressed"),
//                           //     style: 'destructive'
//                           //    // style: "cancel"
//                           //   },
//                           //   { text: "OK", onPress: () => console.log("OK Pressed") }
//                           // ]
//                         )
//                         console.log('ver más :) _', verMas)
//                       }
//                       }>
//                       {seedDescription.substring(0, 200)} ... ver mas
//                     </Text>
//                     //   : verMas === true ?
//                     //   <Text style={styles.seedDescription} 
//                     //     onPress={ () => {
//                     //         console.log('ver más :) _')
//                     //         setVerMas = false
//                     //     }
//                     //     }>
//                     //         {seedDescription} ... ver menos
//                     //   </Text>
//                     :
//                     <Text style={styles.seedDescription} >
//                       {seedDescription}
//                     </Text>
//                   }
//                 </View>

//   <CardRequirements
//     type={type}
//     title={title}
//     seedDescription={seedDescription}
//     seedId={seedId}
//     seedName={'hola seedName'}
//     seedPhoto={imageUrl}
//     origin={origin}
//     thumbnailUrl={imageUrl}
//     imageUrl={
//       imageUrl.includes('.mp4') ?
//         imageUrl :
//         imageUrl.includes('.mov') ?
//          imageUrl :
//            imageUrl}
//     screen={5}
//     qty={qty}
//     mesure={mesure}
//     unitaryPrice={unitaryPrice}
//     currency={currency}
//     sub={sub}
//     note={note}
//     ifBringRequirementItems={() => { 
//      console('aqui ifBringRequirementItems()')
//       //ifBringRequirementItems()
//      }}
//     totalSeedLikes={999}
//     totalSeedComments={333}
//     userId={userId}
//     onPressComment={onPressComment}
//     foundUserChecker={'off'}
//     //seedDate={dateActions(item.createDateSeed)}
//     //content={content}
//     seedOrder={999}
//     //itemsRequirements={itemsRequirements}
//     //statusLike={item.myLike === null ? false : true}
//     //locationRender={item.location}
  
//     //onPressShare={onPressShare}
//   />


// {
//   listing.length === 0 ?
// <Text>nulllllllll</Text>
// :
// <CardSeedOriginContent
// //style={{width:'100%', height:200, backgroundColor:'blue'}}
// title={listing[0].seedName}
// //actionsNum={seedTotalActionsOrigin}
// totalSeedFollowers={seedTotalActionsOrigin}
// //commentsNum={totalSeedCommentsOrigin}
// type={listing[0].type}
// imageUrl={
//     listing[0].seedPhoto.includes('.mp4') ?
//    webUrl + listing[0].seedPhoto :
//     listing[0].seedPhoto.includes('.mov') ?
//     webUrl + listing[0].seedPhoto :
//         listing[0].seedPhoto.includes('.jpg') ?
//         webUrl + listing[0].seedPhoto + '_seedfit.jpg':
//                 listing[0].seedPhoto.includes('.png') ?
//         webUrl + listing[0].seedPhoto + '_seedfit.png':
//        webUrl + listing[0].seedPhoto}

// onPress={() => {
//     console.log('kkkkkkkkkkkkkkkkk', seedId)
//     //onPressForOrigin()
//     var userIdOfFeedItem = listing[0].userId
//     console.log("userIdOfFeedItem en FeedScreen ", userIdOfFeedItem)
//     var foundUserChecker = 'off'
//     if (userIdOfFeedItem === myUserId) {
//       foundUserChecker = 'off'
//     } else {
//       foundUserChecker = 'foundUserChecker'
//     }
//     console.log("foundUserChecker en FeedScreen ", foundUserChecker)
//     var screen = 'FeedScreen'   // 'ListingsSeedsScreen'
//     var item = listing[0]
//     navigation.navigate(routes.SEED_DETAILS, { item, screen, foundUserChecker })
// }
// }
// thumbnailUrl={   listing[0].seedPhoto.includes('.jpg') ?
//         webUrl + listing[0].seedPhoto + '_seedfit.jpg':
//                 listing[0].seedPhoto.includes('.png') ?
//         webUrl + listing[0].seedPhoto + '_seedfit.png':
//        webUrl + listing[0].seedPhoto}
// seedTotalSeedFollowersOrigin={listing[0].totalSeedFollowers}
// />
// }


//                 <ListItemAccount
//                   titleRol={userName}
//                   image={userPhoto}
//                   onPress={() => {
//                     if (userId !== JSON.parse(user).userId) {
//                       var foundUserChecker = "foundUserChecker"
//                       var index = 0
//                       var item = { userId: userId, userName: userName, userPhoto: userPhotoFoundUser, alias: alias, userDescription: userDescription }
//                       navigation.navigate(routes.FOUND_USER, { item, userId, foundUserChecker, index })
//                     } else {
//                       navigation.navigate(routes.NO_BOTTON)
//                     }
//                   }
//                   }
//                 />
//                 {/* </TouchableOpacity> */}
//                 <View style={styles.detailsContainer}>

//                   <View style={styles.likeAndCommentContainer}>
//                     <View style={styles.likeContainer}>
//                       <TouchableOpacity style={styles.subTitle}
//                         onPress={onPressNumLikes}
//                       >
//                         <Text  // Número de cerebros like
//                           numberOfLines={2}
//                           style={styles.textNumLikes}
//                         >

//                           {
//                             // '10000' +
//                             subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//                             //intWithCommaFilter(subTitle)
//                             //subTitle.toLocaleString()

//                             // subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//                             // abc('10000' +
//                             //   subTitle)
//                           }
//                         </Text>
//                       </TouchableOpacity>
//                       <LikeBrainButton style={styles.brain} onPress={onPressLike} statusLike={statusLike} />
//                     </View>

//                     <View style={styles.commentContainer}>
//                       <Text style={styles.commentsNum} // Número de comments
//                         numberOfLines={1} >
//                         {commentsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                       </Text>
//                       <TouchableOpacity style={styles.commentsNum}
//                         onPress={onPressComment}
//                       >
//                         <MaterialCommunityIcons style={styles.comments}
//                           name={"comment-text-outline"}
//                           color={"grey"}
//                           size={27}
//                         />
//                       </TouchableOpacity>
//                     </View>

//                     <View style={styles.actionContainer}>
//                       {/* <TouchableOpacity style={styles.actionsNum} onPress={onPressNumLikes} >
//                       </TouchableOpacity> */}
//                       <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
//                         numberOfLines={1} >
//                         {actionsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                       </Text>
//                       <Entypo name={"tree"}
//                         color={"grey"}
//                         size={27}
//                         onPress={onPress}
//                         style={styles.tree}
//                       />
//                     </View>
//                     <View style={styles.followersSeedContainer}>
//                       <TouchableOpacity
//                         //style={styles.textFollower}
//                         onPress={onPressFolloresSeed} >
//                         <Text style={styles.textFollower} // Número de acciones(ramas)Tree
//                         //numberOfLines={1}
//                         >
//                           {followersSeed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                         </Text>
//                         <Ionicons style={styles.followersSeed}
//                           name="people"
//                           size={27}
//                           color="grey"
//                         />
//                       </TouchableOpacity>
//                     </View>
//                   </View>
//                 </View>
//               </View>
//             )    

// //     Add  S U B - S U P P O R T  apoyos
//         case 41:
//             return (
//               <View style={styles.card}>
//                 {/* <TouchableOpacity onPress={onPress}> */}
//                 <View>
//                   <View style={styles.containerIcon}>
//                     {
//                       type === 41 ?
//                         <View style={styles.viewIconAndNameAction}>
//                       <FontAwesome5 style={{ 
//                         marginLeft: (windowWidth * .03),
//                         marginTop: (windowHeight * 0),
//                         backgroundColor:colors.fuente,
//                         borderColor:'yellow',
//                         borderWidth:1,
//                         borderRadius:5
//                       }}
//                         name="hand-holding-heart"
//                         size={35} //35
//                         color="yellow"
//                       // onPress={() => {
//                       //   listAcciones === false ?
//                       //   setListAcciones(true)
//                       //     :
//                       //   setListAcciones(false)
//                       // }}
//                       />
//                           <Text style={styles.actionNameApoyo}> Apoyo </Text>

//                           <Entypo style={{
//                             // marginLeft:'55%'
//                             marginLeft: (windowWidth * .30)
//                           }}
//                             name="share"
//                             size={28}
//                             color="grey"
//                             onPress={onPressShare}
//                           />
//                         </View>
                    
//                       :
//                       null
//                     }
//                   </View>
//                   {/* <Entypo style={{ marginLeft:'80%'}} name="share" size={28} color="black" onPress={onPressShare} /> */}

//                 </View>

//   <CardRequirements
//     type={type}
//     title={title}
//     seedDescription={seedDescription}
//     seedId={seedId}
//     seedName={'hola seedName'}
//     seedPhoto={imageUrl}
//     origin={origin}
//     thumbnailUrl={imageUrl}
//     imageUrl={
//       imageUrl.includes('.mp4') ?
//         imageUrl :
//         imageUrl.includes('.mov') ?
//          imageUrl :
//            imageUrl}
//     screen={6}
//     qty={qty}
//     mesure={mesure}
//     unitaryPrice={unitaryPrice}
//     currency={currency}
//     sub={sub}
//     note={note}
//     ifBringRequirementItems={() => { 
//      console('aqui ifBringRequirementItems()')
//       //ifBringRequirementItems()
//      }}
//     totalSeedLikes={999}
//     totalSeedComments={333}
//     userId={userId}
//     onPressComment={onPressComment}
//     foundUserChecker={'off'}
//     seedDate={createDateSeed}
//     //content={content}
//     seedOrder={999}
//     //itemsRequirements={itemsRequirements}
//     //statusLike={item.myLike === null ? false : true}
//     //locationRender={item.location}
  
//     //onPressShare={onPressShare}
//   />

// <CardSeedOriginContent
// //style={{width:'100%', height:200, backgroundColor:'blue'}}
// title={seedNameOrigin}
// subTitle={seedTotalSeedLikesOrigin} // 
// //actionsNum={seedTotalActionsOrigin}
// totalSeedFollowers={seedTotalActionsOrigin}
// //commentsNum={totalSeedCommentsOrigin}
// type={typeOrigin}
// onPressNumLikes={() => {
//     // indexLike = index
//     // var pick = items[index].seedId
//     navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, { seedId });
//     console.log("presNumLique")
// }
// }
// imageUrl={
//     seedPhotoOrigin.includes('.mp4') ?
//     seedPhotoOrigin :
//     seedPhotoOrigin.includes('.mov') ?
//         seedPhotoOrigin :
//         seedPhotoOrigin}

// onPress={() => {
//     console.log('kkkkkkkkkkkkkkkkk', seedId)
//     onPressForOrigin()
//     // pickSeedId = items[index].seedId
//     // getDataFromSeedActions()
//     //navigation.navigate(routes.SEED_DETAILS, { origin }) //item
// }
// }
// thumbnailUrl={seedPhotoOrigin}
// seedTotalSeedFollowersOrigin={seedTotalSeedFollowersOrigin}
// />   



//                 <ListItemAccount
//                   titleRol={userName}
//                   image={userPhoto}
//                   onPress={() => {
//                     if (userId !== JSON.parse(user).userId) {
//                       var foundUserChecker = "foundUserChecker"
//                       var index = 0
//                       var item = { userId: userId, userName: userName, userPhoto: userPhotoFoundUser, alias: alias, userDescription: userDescription }
//                       navigation.navigate(routes.FOUND_USER, { item, userId, foundUserChecker, index })
//                     } else {
//                       navigation.navigate(routes.NO_BOTTON)
//                     }
//                   }
//                   }
//                 />
//                 {/* </TouchableOpacity> */}
//                 <View style={styles.detailsContainer}>

//                   <View style={styles.likeAndCommentContainer}>
//                     <View style={styles.likeContainer}>
//                       <TouchableOpacity style={styles.subTitle}
//                         onPress={onPressNumLikes}
//                       >
//                         <Text  // Número de cerebros like
//                           numberOfLines={2}
//                           style={styles.textNumLikes}
//                         >

//                           {
//                             // '10000' +
//                             subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//                             //intWithCommaFilter(subTitle)
//                             //subTitle.toLocaleString()

//                             // subTitle.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//                             // abc('10000' +
//                             //   subTitle)
//                           }
//                         </Text>
//                       </TouchableOpacity>
//                       <LikeBrainButton style={styles.brain} onPress={onPressLike} statusLike={statusLike} />
//                     </View>

//                     <View style={styles.commentContainer}>
//                       <Text style={styles.commentsNum} // Número de comments
//                         numberOfLines={1} >
//                         {commentsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                       </Text>
//                       <TouchableOpacity style={styles.commentsNum}
//                         onPress={onPressComment}
//                       >
//                         <MaterialCommunityIcons style={styles.comments}
//                           name={"comment-text-outline"}
//                           color={"grey"}
//                           size={27}
//                         />
//                       </TouchableOpacity>
//                     </View>

//                     <View style={styles.actionContainer}>
//                       {/* <TouchableOpacity style={styles.actionsNum} onPress={onPressNumLikes} >
//                       </TouchableOpacity> */}
//                       <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
//                         numberOfLines={1} >
//                         {actionsNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                       </Text>
//                       <Entypo name={"tree"}
//                         color={"grey"}
//                         size={27}
//                         onPress={onPress}
//                         style={styles.tree}
//                       />
//                     </View>
//                     <View style={styles.followersSeedContainer}>
//                       <TouchableOpacity
//                         //style={styles.textFollower}
//                         onPress={onPressFolloresSeed} >
//                         <Text style={styles.textFollower} // Número de acciones(ramas)Tree
//                         //numberOfLines={1}
//                         >
//                           {followersSeed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
//                         </Text>
//                         <Ionicons style={styles.followersSeed}
//                           name="people"
//                           size={27}
//                           color="grey"
//                         />
//                       </TouchableOpacity>
//                     </View>
//                   </View>
//                 </View>
//               </View>
//             )             
    }


}

const styles = StyleSheet.create({
    txtYoutube: {
      alignSelf:'center',
      marginLeft: (windowHeight * .015),
      marginRight: (windowHeight * .015),
      fontSize: textLarge,
      color: colors.textGeneral
    },
    youtubeVideo: {
    width: "100%",
    marginBottom: 4,
    //backgroundColor: colors.pistache,
  },
    seedDescription6: {
    marginBottom: 7,
    marginTop: "1.5%",
    width: "350%",
    textAlign: "justify",
    fontSize: textSmall,     //(windowWidth *.041), //17, 
  },
    Title6: {
      fontSize: textMedium,    //(windowWidth *.043),  //17,  
      //color: colors.textGeneral,
      //marginLeft: "32%",
      marginTop: "25%",
      width: "350%",
      textAlign: "justify",
      fontWeight: textStyles.fontWeightMedium,
    },
    image6: {
      width: (windowWidth * .42), //"380%", // A menor porcentaje en el marginLeft se requiere aumentar el width para que la foto se haga cuadrada en vez de rectangular.
      height: (windowWidth * .50), //200,
      marginLeft: "10%", // Cada que reducia el marginLeft me hacía la foto más rectangular, tuve que aumentar el width.
      alignContent: "space-around",
      backgroundColor: colors.fondoImagenes,
      alignItems: "center",
    },
    viewContent6TitleYSeedDescription: {
      backgroundColor: colors.fondoGeneral,
      width: "15%",
      marginLeft: "4%",
      alignSelf: "center",
    },
    viewContent6PhotoYText: {
      //borderRadius: 15,
      backgroundColor: colors.fondoInput,
      //marginBottom: 15,
      //overflow: "hidden",
      flexDirection: "row",
    },
    viewContent6Image: {
    //backgroundColor: "red", //colors.chakra2ama,
    justifyContent: 'center', // Esto hace que las imágenes se centren verticalmente no importando que tanto crezca el texto.
    //alignItems: 'center',
    backgroundColor: '#00000000', // Le puse este color esperando se vuelva transparente '#00000000',
  },
    viewImage7: {
    width: (windowWidth * .42),
    height: (windowWidth * .50),
    alignItems: "center",
    justifyContent: "center",
    marginRight: (windowWidth * .05),  //"1%",
  },
    viewContent6PhotoYText: {
      //borderRadius: 15,
      backgroundColor: colors.fondoInput,
      //marginBottom: 15,
      //overflow: "hidden",
      flexDirection: "row",
    },
  viewContent6TitleYSeedDescription: {
    backgroundColor: colors.fondoGeneral,
    width: "15%",
    marginLeft: "4%",
    alignSelf: "center",
  },
    viewContent7TitleYSeedDescription: {
      //backgroundColor: colors.fondoGeneral,
      //width: "15%",
      marginLeft: "2%",
      alignSelf: "center",
    },
    viewContent7Image: {
    justifyContent: 'center',
    alignSelf: 'center',
    backgroundColor: '#00000000', // Le puse este color esperando se vuelva transparente '#00000000',
    width: "66%", // A mayo porcentaje en el marginLeft se requiere disminuir el width para que la foto se haga cuadrada en vez de rectangular.
    height: 230,
    marginLeft: "38%", // Cada que aumentaba el marginLeft me hacía la foto más rectangular, tuve que disminuir el width.
  },

    image7: {
      width: (windowWidth * .42),   //"63%", // A mayo porcentaje en el marginLeft se requiere disminuir el width para que la foto se haga cuadrada en vez de rectangular.
      height: (windowWidth * .50),   //200,
      //marginLeft: "63.5%", // Cada que aumentaba el marginLeft me hacía la foto más rectangular, tuve que disminuir el width.
      alignContent: "space-around",
      backgroundColor: colors.fondoImagenes,
    },
  likeContainer: {
    alignItems: "center",
    width: 80,
    //backgroundColor: "blue",

  },
  commentContainer: {
    alignItems: "center",
    width: 80,
    // backgroundColor: "red",

  },
  actionContainer: {
    alignItems: "center",
    width: 80,
    //backgroundColor: "green",
  },
  followersSeedContainer: {
    textAlign: "center",
    alignItems: "center",
    width: 80,
    //  backgroundColor: "braun",
  },
  containerIcon: {
    alignSelf: "center",
   // marginRight: (windowWidth * .015),
    marginTop: (windowWidth * .01),
    //backgroundColor: "red", 
    width: "90%",
    height: (windowHeight * .05),
    //marginBottom: '2%',
    zIndex: 1,
  },
  viewIconAndNameAction: {
    flexDirection: "row",
    //alignSelf: "flex-start",
    //backgroundColor: "blue", 
    alignItems: "center",
    // width:'60%',
    marginLeft: "35.5%",
  },
    actionNameApoyo: {
    fontSize: 17,
    color: colors.green,
   // marginTop: "4%",
    fontWeight: '3000',//textStyles.fontWeightMedium,
    //textAlign: "center",
    //alignSelf: "center",
    textAlignVertical: "center",
    marginRight: "1.5%",
  },
  actionName: {
    fontSize: textSmall,
    color: colors.textGeneral,
    marginTop: "4%",
    textAlignVertical: "bottom",
    //marginRight: "1.5%",
  },
  iconOfAction0: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: "#8DF78D",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 1,
    alignSelf: "flex-end",
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: "#EBAB91"
  },
  iconOfAction1: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra1nar,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 1,
    alignSelf: "flex-end",
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction2: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra2ama,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction3: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra3ver,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction4: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: "blue",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction5: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra5vlt,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction6: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra6rsa,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction7: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra7ryo,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  iconOfAction8: {
    flexDirection: "row",
    height: (windowWidth * .08),
    width: (windowWidth * .08),
    borderRadius: 25,
    borderWidth: 4,
    borderColor: colors.chakra9aur,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "-1.2%",
    zIndex: 2,
    alignSelf: "flex-end",
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: 3,
    backgroundColor: colors.fondoImagenes
  },
  card: {
    width: (windowWidth * .97),
    //height: 500, 
    alignSelf: 'center',
    borderRadius: 15,
    backgroundColor: colors.fondoInput,
    marginBottom: 15,
    overflow: "hidden",
  },
  detailsContainer: {
    padding: 20,
  },
   imageSeedOrigin: {
    //marginTop: (windowHeight * .015),
    width: (windowWidth * .5),//"100%",
    height: (windowHeight * .15), //250, //250,
    //borderRadius: 15,
    alignItems: "center",
    alignSelf: "center",
    backgroundColor: colors.fondoImagenes
  },
  image: {
    //marginTop: (windowHeight * .015),
    width: (windowWidth * .9),//"100%",
    height: (windowHeight * .35), //250, //250,
    //borderRadius: 15,
    alignItems: "center",
    alignSelf: "center",
    backgroundColor: colors.fondoImagenes
  },
  imageViewSeedOrigin: {       // Css para el image del support y este actua en conjunto con viewImageSupport
    width: (windowWidth * .5), //400,  
    height: (windowHeight * .2), //250, //(windowWidth* .343),  
   // justifyContent: "center",
    //alignItems: "center",
    //alignSelf: "center",
  },
  imageView: {       // Css para el image del support y este actua en conjunto con viewImageSupport
    width: (windowWidth * .9), //400,  
    height: (windowHeight * .4), //250, //(windowWidth* .343),  
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
  },
  imageMountain: {
    width: (windowWidth), //"100%",
    height: (windowHeight * .343), //250,
    alignItems: "center"
  },
  likeAndCommentContainer: {
    flexDirection: "row",
    width: "100%",
    height: 40,
    marginTop: "-5%",
    marginBottom: "5%",
  },
  likeAndCommentNumbersContainer: {
    flexDirection: "row",
    width: "100%",
    height: 40,
    marginTop: "3%",
  },
  likes: {
    fontSize: textSmall,
    marginLeft: "20%",
    color: colors.medium
  },
  actionsNum: {
    fontSize: textMini,
    marginBottom: 6,
    color: colors.medium
  },
  commentsNum: {
    fontSize: textMini,
    marginBottom: 6,
    color: colors.medium
  },
  brain: {
    fontSize: sizeBrainComments,

    //marginLeft: (windowWidth * .06),
    // width: (windowWidth * .1),
    // height: '100%',
  },
  comments: {
    fontSize: sizeBrainComments,
    //marginLeft: (windowWidth * .14)
    //marginLeft: "18%",
    // color: colors.medium,

  },
  followersSeed: {
    fontSize: sizeBrainComments,
    //marginLeft: (windowWidth * .15)
    //marginLeft: "18%",
    //color: colors.textGeneral,
  },
  tree: {
    fontSize: sizeTree,
    //marginLeft: "18%",
    //marginLeft: (windowWidth * .15)
    //color: colors.textGeneral,
  },
  textNumLikes: {
    fontSize: textMini,
    marginBottom: 5,
    // color: colors.chakra0red,
  },
  subTitle: {
    //backgroundColor: 'red',
    // marginLeft: "5%",
    marginBottom: 5,
    textAlign: 'center',
    // height: 20,
    // width: 20
  },
  date: {
        //backgroundColor: 'red',

    fontSize: textSmall,
     marginLeft:(windowWidth * .01),
     marginTop: (windowWidth * .02),
     marginBottom: (windowWidth * .02),
      //width: '100%',
    color: colors.textGeneral,
     alignSelf:'center',
    // textAlign: "justify",

  },
  title: {
    textAlign: "justify",
    fontSize: textMedium,
    fontWeight: 'bold',
    color: colors.textGeneral,
    marginBottom: 2,
    padding: 5,//(windowWidth * .97),
    alignSelf: 'center',
  },
  seedDescription: {
    textAlign: "justify",
    fontSize: textSmall,
    fontWeight: textStyles.fontWeightMedium,
    color: colors.textGeneral,
    marginBottom: 2,
    padding: 5,//(windowWidth * .97),
    alignSelf: 'center',
  },
  textFollower: {
    alignSelf: "center",
    fontSize: textMini,
    marginBottom: 5,
    color: colors.medium
  }
});
export default CardFeedContent;